import React from 'react';
import Link from 'next/link';
import LogoPart from '../LogoPart';
import { WithTranslation } from 'next-i18next';
import { withTranslation } from 'next-i18next';
import { Button } from '@lb-classroom/ui';

interface PassedProps {
  t: any;
}

type Props = WithTranslation & PassedProps;

const GuestHeaderNew: React.FC<Props> = ({ t }: Props) => {
  return (
    <nav className="bg-white border-b border-light-gray">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <LogoPart />
          </div>
          <div className="flex items-center space-x-4">
            <Link href="/login">
              <Button variant="ghost">{t('service.header.login')}</Button>
            </Link>
            <Link href="/signup">
              <Button>{t('service.header.signup')}</Button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

const wrapped = withTranslation('common')(GuestHeaderNew);

export default wrapped;
